export enum RugbyLeagueTurnoverAttribute {
  Handover = 3004,
  KnockOn = 3005,
  ForwardPass = 3006,
  Intercepted = 3007,
  ForcedIntoTouch = 3008,
  LostInScrum = 3009,
}
